import type {
    CreateAnnouncementPayload,
    UpdateAnnouncementPayload,
} from './types';

import { baseRequest } from '@/lib/base';

// ── List own announcements (paginated) ──
export interface FetchAnnouncementsParams {
    page?: number;
    page_size?: number;
    ordering?: string;
}

export const fetchAnnouncements = (
    params: FetchAnnouncementsParams = {},
) => {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
            sp.set(key, String(value));
        }
    });
    const qs = sp.toString();
    return baseRequest({
        url: `/inventory/announcements/${qs ? `?${qs}` : ''}`,
    });
};

// ── Get announcement detail ──
export const fetchAnnouncement = (slug: string) => baseRequest({
    url: `/inventory/announcements/${slug}/`,
});

// ── Create announcement ──
export const createAnnouncement = (
    data: CreateAnnouncementPayload,
) => baseRequest({
    url: '/inventory/announcements/create/',
    method: 'POST',
    body: data,
});

// ── Update announcement ──
export const updateAnnouncement = (
    slug: string,
    data: UpdateAnnouncementPayload,
) => baseRequest({
    url: `/inventory/announcements/${slug}/update/`,
    method: 'PATCH',
    body: data,
});

// ── Delete announcement ──
export const deleteAnnouncement = (slug: string) => baseRequest({
    url: `/inventory/announcements/${slug}/delete/`,
    method: 'DELETE',
});

// ── Billboard (from connected parties) ──
export interface FetchBillboardParams {
    page?: number;
    page_size?: number;
    ordering?: string;
}

export const fetchBillboard = (
    params: FetchBillboardParams = {},
) => {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
            sp.set(key, String(value));
        }
    });
    const qs = sp.toString();
    return baseRequest({
        url: `/inventory/announcements/billboard/${qs ? `?${qs}` : ''}`,
    });
};
